import React from 'react';
import { Collapse as CollapseCustom, UnmountClosed } from 'react-collapse';
var Collapse = function (_a) {
    var isOpen = _a.isOpen, className = _a.className, children = _a.children, isUnmount = _a.isUnmount;
    if (isUnmount) {
        return (React.createElement(UnmountClosed, { isOpened: isOpen },
            React.createElement("div", { className: className ? className : '' }, children)));
    }
    else {
        return (React.createElement(CollapseCustom, { isOpened: isOpen },
            React.createElement("div", { className: className ? className : '' }, children)));
    }
};
export { Collapse };
//# sourceMappingURL=Collapse.js.map